import { Checkbox } from "@mui/material";
import Modal from "@mui/material/Modal";
// import axios from "axios";
import { saveAs } from "file-saver";
import React, { useEffect, useState } from "react";
import { FiChevronDown, FiEye } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import { FormatStatus } from "../../../../../utils/functions/FormatStatus";
import { formatDate } from "../../../../../utils/hooks/convertDate";
import { convertToDecimal } from "../../../../../utils/hooks/useConvertToDecimal";
import {
  useApprovePaymentRequestMutation,
  useGetPaymentSummaryQuery,
  useGeneratePaymentScheduleMutation,
  useDeclinePaymentRequestMutation,
} from "../../../../api";
import PageStyle from "../../../Components/Layout/FinancePageLayout";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { CalendarFilter2, ProDropFilter, SearchFilter } from "../../../Components/Search/Search";
import Table from "../../../Components/Table/Table";
import DashboardStyle from "../../../Styles//Dashboard.module.css";
import CreateAccrued from "./createAccrued";
import axios from "axios";
import { URL } from "../../../../../utils/routes";
import Pagination from "../../../Components/Pagination/Pagination";

let currentHeaders = [
  {
    title: "Batch ID",
    key: "BatchID",
  },
  {
    title: "Payment  Type",
    key: "PaymentType",
  },
  {
    title: "Requisition Date",
    key: "RequisitionDate",
  },
  {
    title: "Total Amount",
    key: "TotalAmount",
  },
  {
    title: "Request Status",
    key: "RequestStatus",
  },
  {
    title: "Actions",
    key: null,
  },
];

const PaymentRequest = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = React.useState(1);
  const successValue = useSelector((state) => state?.global?.value);
  const [open, setOpen] = useState(false);
  const handleChange = (event, value) => {
    setPage(value);
  };
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (successValue === "success") {
      setOpen(false);
    }
  }, [successValue]);

  const [checked, setChecked] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  console.log('selected items', selectedItems);
  // const [selectedBatchId, setSelectedBatchId] = useState([]);
  const [loading, setIsloading] = useState(false);
  const navigate = useNavigate();
  const [approvalStatus, setApprovalStatus] = useState(pathname?.includes(URL.PaymentRequestHOD) ? 0 : 1);
  const itemsPerPage = 10;
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10)
const [endDate, setEndDate] = useState('')
const [startDate, setStartDate] = useState('');
  const { data: paymentReqData, error } = useGetPaymentSummaryQuery({
    PageSize: pageSize,
    ApprovalStatus: approvalStatus,
    PageNumber: pageNumber, StartDate: startDate, EndDate: endDate
  });
  const filteredData = !error ? paymentReqData?.responseObject?.pageItems.filter((item) => {
    const paymentType = item?.paymentType?.toLowerCase();
    const searchTerm = search?.toLowerCase();

    return paymentType && paymentType.includes(searchTerm);
  }): [];
  const slicedData = filteredData?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );
  const [onGeneratePayment] = useGeneratePaymentScheduleMutation();

  const filteredDataByStatus = slicedData;
  const filterBy = [
    {
      name: "Approved",
      filter: 0,
    },
    {
      name: "Pending",
      filter: 1,
    },
    {
      name: "Paid",
      filter: 13,
    },
    {
      name: "AwaitingControlApproval",
      filter: 102,
    },
    {
      name: "AwaitingControlReview",
      filter: 101,
    },
    {
      name: "ApproveFinance",
      filter: 103,
    },
  ];

  useEffect(() => {
    setChecked(
      filteredDataByStatus?.length > 0 &&
      selectedItems?.length === filteredDataByStatus?.length
    );
  }, [selectedItems, filteredDataByStatus]);

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      // Select all items except those with approvalStatus === 0
      const filteredItems = filteredDataByStatus.filter(
        (item) =>
          item.approvalStatus !== 0 &&
          item.approvalStatus !== 101 &&
          item.approvalStatus !== 102
      );

      setSelectedItems(filteredItems);
    } else {
      setSelectedItems([]); // Deselect all items
    }
    setChecked(isChecked); // Update "Select All" checkbox state
  };

  // Handle individual checkbox change
  const handleCheckboxChange = (item, isChecked) => {
    setSelectedItems((prev) => {
      if (isChecked) {
        // Add item if checked and not already selected
        if (!prev.some((selectedItem) => selectedItem.id === item.id)) {
          return [...prev, item];
        }
      } else {
        // Remove item if unchecked
        return prev.filter((selectedItem) => selectedItem.id !== item.id);
      }
      return prev;
    });
  };
  const [downloading, setDownloading] = useState(false)
  const [comment, setComment] = useState('');
  const token = JSON.parse(localStorage.getItem("user"))?.userToken;
  const generatePaymentSchedule = async () => {
    setDownloading(true);
    const ids = selectedItems?.filter(dat => dat?.approvalStatus === 13 || dat?.approvalStatus === 0)?.map(item => item?.batchId)

    axios.post(`${process.env.REACT_APP_BACKEND_FINANCE_URL}/payrollpayment/generateschedule`,
      {
        BatchIds: ids
      }
      , {
        headers: {
          Authorization: `Bearer ${token}`,
        }, responseType: 'blob'
      }).then(data => { 
        const url = window.URL.createObjectURL(data.data);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'payment-schedule';
        a.click();
        window.URL.revokeObjectURL(url);
      }).catch(err => console.log(err))
      .finally(dat => setDownloading(false))
  }



  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const [onApprovePaymentReq] = useApprovePaymentRequestMutation();
  const [onDeclinePaymentReq] = useDeclinePaymentRequestMutation()

  const handleApprovePaymentRequest = async () => {
    try {
      setIsloading(true); 
      let res;
      if (open === "Approve") {
        res = await onApprovePaymentReq({
          paymentIds: selectedItems?.map(dat => dat?.id),
          status: pathname?.includes(URL.PaymentRequestHOD) ? 103 : 0
        });
      }
      else {
        res = await onDeclinePaymentReq({
          paymentIds: selectedItems.map((item) => item.id),
          comment: comment,
          status: 7,
          type: 'control'
        });
      }
      console.log("res", res);
      if (res?.data?.successful === true) {
        toast.success(res?.data?.statusMessage);
        setIsloading(false);
        setOpen(false);
      } else {
        setIsloading(false);
        toast.error(res?.error?.data?.statusMessage);
      }
    } catch (err) {
      setIsloading(false);
      toast.error(err);
    }
  }; 
  return (
    <RouteLayout title={"Payment Requests"}>
      <PageStyle title={`Payment Requests  ${pathname?.includes(URL.PaymentRequestHOD) ? "H.O.D" : ''}`} hasBack={false} isMain={true}>
        <div className="w-full flex items-end justify-between mb-3">
          <div className="flex items-center justify-end gap-5">
            <SearchFilter label={'Search'}
              text={(value) => setSearch(value)}
              fromHeader={true}
              onChange={handleSearch}
            />
            <ProDropFilter hideLabel={true}
              filter={approvalStatus} name={'Status'}
              setFilter={setApprovalStatus}
              filterBy={filterBy}
            />
                      <CalendarFilter2 
            setStartDate={setStartDate}
            setEndDate={setEndDate}
          />
          </div>
          <div className="flex items-end justify-between gap-2">
            <button
              disabled={selectedItems?.filter(dat => dat?.approvalStatus === 13 || dat?.approvalStatus === 0)?.length < 1}
              // disabled={selectedBatchId.length < 1}
              onClick={() => generatePaymentSchedule()}
              className="bg-[#29382A]/90 text-white px-2 rounded-md flex gap-3 items-center py-4"
            >
              <p>{downloading ? "Downloading..." : "Download Schedule"}</p>
            </button>
            {!pathname?.includes(URL.DownloadPaymentRequest) && <>
              <button
                disabled={selectedItems.length < 1 || selectedItems?.some(dat => dat?.approvalStatus === 103)}
                onClick={() => setOpen("Approve")}
                className="bg-[#29382A]/90 text-white px-2 rounded-md flex gap-3 items-center py-4"
              >
                <p>
                  {selectedItems.length < 1 || selectedItems?.some(dat => dat?.approvalStatus === 103)
                    ? "Select Items to Approve"
                    : "Approve"}
                </p>
                <span>
                  <FiChevronDown />
                </span>
              </button>
              <button
                disabled={selectedItems.length < 1 || selectedItems?.some(dat => dat?.approvalStatus === 103)}
                onClick={() => setOpen("Decline")}
                className="bg-red-600 text-white px-2 rounded-md flex gap-3 items-center py-4"
              >
                <p>
                  {selectedItems.length < 1 || selectedItems?.some(dat => dat?.approvalStatus === 103)
                    ? "Select Items to Decline"
                    : "Decline"}
                </p>
                <span>
                  <FiChevronDown />
                </span>
              </button> </>
            }

          </div>
        </div>
        <div className={DashboardStyle.dashboard_table_holder}>
          <Table>
            <thead>
              <tr>
                <th>
                  <Checkbox
                    checked={checked}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                  />
                </th>
                {/* <th className="text-[#29382A] ">ID</th> */}
                {currentHeaders.map((header, _index) => (
                  <th
                    className={`!text-[#29382A] ${header.title === "Actions" && "flex justify-end !pr-6"
                      }`}
                    key={_index + 1}
                  >
                    {header.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {/* {slicedData?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <Checkbox
                        checked={selectedItems.includes(item.id)}
                        onChange={(e) =>
                          handleCheckboxChange(item, e.target.checked)
                        }
                      />
                    </td>
                    <td className="text-[#29382A] ">{item?.batchId}</td>
                    <td>{item?.paymentType ?? "--"}</td>
                    <td>{formatDate(item?.createdDate) ?? "--"}</td>
                    <td>₦ {convertToDecimal(item?.totalAmount) ?? "--"} </td>
                    <td>{FormatStatus(item?.approvalStatus)}</td>
                    <td>
                      <div className={`flex justify-end bg-transparent`}>
                        <div className="flex rounded-[8px] overflow-hidden">
                          <button
                            onClick={() =>
                              navigate(
                                `/dashboard/finance/Payment-Request/Payment-Details/${JSON.stringify(
                                  {
                                    // batchId: item?.batchId,
                                    id: item?.id,
                                    PaymentTypeId: item?.paymentTypeId,
                                    CreatedDate: item?.createdDate,
                                  }
                                )}`
                              )
                            }
                            className="bg-[#6E9170] text-white p-3"
                          >
                            <FiEye />
                          </button>
                          <button
                            // onClick={handlePopoverClick}
                            className="bg-[#29382A] p-3 text-white"
                          >
                            <FiChevronDown />
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })} */}
              {filteredDataByStatus?.map((item, index) => {
                const isApproved = [0, 10, 20, 30, 40, 50, 60].includes(
                  item?.approvalStatus
                );
                return (
                  <tr key={index}>
                    <td>
                      <Checkbox
                        disabled={
                          (!isApproved &&
                            (item?.approvalStatus === 101 ||
                              item?.approvalStatus === 102))
                        }
                        checked={selectedItems.some(
                          (selectedItem) => selectedItem.id === item.id
                        )}
                        onChange={(e) =>
                          handleCheckboxChange(item, e.target.checked)
                        }
                      />
                    </td>
                    <td className="text-[#29382A] ">{item?.batchId}</td>
                    <td>{item?.paymentType ?? "--"}</td>
                    <td>{formatDate(item?.createdDate) ?? "--"}</td>
                    <td>₦ {convertToDecimal(item?.totalAmount) ?? "--"} </td>
                    <td>{FormatStatus(item?.approvalStatus)}</td>
                    <td>
                      <div className={`flex justify-end bg-transparent`}>
                        <div className="flex rounded-[8px] overflow-hidden">
                          <button
                            onClick={() =>
                              navigate(
                                `/dashboard/finance/Payment-Request/Payment-Details/${JSON.stringify(
                                  {
                                    batchId: item?.batchId,
                                    id: item?.id,
                                    PaymentTypeId: item?.paymentTypeId,
                                    CreatedDate: item?.createdDate,
                                  }
                                )}`
                              )
                            }
                            className="bg-[#6E9170] text-white p-3"
                          >
                            <FiEye />
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>

        <div className="flex justify-between">
          <p>Showing page: {page}</p>

          <Pagination
            last_page={paymentReqData?.responseObject?.previousPage}
            present_page={paymentReqData?.responseObject?.currentPage}
            totalRows={paymentReqData?.responseObject?.totalNumberOfPages}
            pageSize={pageSize}
            setPageSize={(page) => setPageSize(page)}
            click={(page) => setPageNumber(page)}
          />
        </div>
        <>

          {open && (
            <Modal
              open={open}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div className="flex justify-center items-center">
                <div className="bg-[#FFFFFF] w-[500px] p-[24px] mt-[10%] rounded-[12px]">
                  <div className="flex justify-center items-center mb-5">
                    <div className={`${open === "Approve" ? "bg-[#4B664C]/70" : 'bg-red-600'} p-2 rounded-full`}>
                      <div className={`${open === "Approve" ? "bg-[#4B664C]/70" : 'bg-red-600'} p-2 rounded-full`}>
                        <div className=" w-[24px] flex justify-center">
                          <p className="text-white">!</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-5">
                    <h3 className="text-[18px] font-[500] text-center">
                      {open} Payment Request
                    </h3>
                  </div>

                  <div className={DashboardStyle.textyarea}>
                    <label>
                      Comment
                    </label>
                    <textarea
                      rows={6}
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      style={{
                        border: "1px solid #D5D5D5",
                        borderRadius: "5px",
                        width: "100%",
                        padding: "10px",
                      }}
                    >
                      Enter Comment
                    </textarea>
                  </div>

                  <div className="my-5">
                    <p className="text-center text-[#4B664C]">
                      Are you sure you want to <span className="lowercase">{open} </span> all the payment request
                      of <strong>{selectedItems?.length}</strong> employees
                    </p>
                  </div>

                  <div className="flex justify-between">
                    <div>
                      <button
                        onClick={() => setOpen(!open)}
                        className={`${open !== "Approve" ? "bg-[#4B664C]/70" : 'bg-red-600/70'} py-[10px] px-[18px]  text-white shadow-md border rounded-[8px] w-[120px]`}
                      >
                        No, Cancel
                      </button>
                    </div>
                    <div>
                      <button
                        onClick={handleApprovePaymentRequest}
                        disabled={loading}
                        className={` py-[10px] px-[18px] text-white rounded-[8px] ${open === "Approve" ? "bg-[#4B664C]" : 'bg-red-600'}`}
                      >
                        {loading ? `${open}ing...` : `Yes ${open}`}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          )}

          {/* {open && (
            <Modal
              open={open}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div className="flex justify-center items-center">
                <div className="bg-[#FFFFFF] w-[700px] p-[24px] mt-[10%] rounded-[12px]">
                  <div className="flex justify-center items-center mb-5">
                    <div className="bg-[#4B664C]/70 p-2 rounded-full">
                      <div className="bg-[#4B664C]/60 p-2 rounded-full">
                        <div className=" w-[24px] flex justify-center">
                          <p className="text-white">!</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-5">
                    <h3 className="text-[18px] font-[500] text-center">
                      Approve Payment Request
                    </h3>
                  </div>
                  <div className="mb-5">

                    <p className="text-center text-[#4B664C]">
                      Are you sure you want to approve all the payment request
                      of <strong>{selectedItems?.filter(dat => dat?.approvalStatus === 1)?.length}</strong> employees
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <div>
                      <button
                        onClick={() => setOpen(!open)}
                        className="py-[10px] px-[18px] bg-[#D92D20] text-white shadow-md border rounded-[8px] w-[120px]"
                      >
                        No, Cancel
                      </button>
                    </div>
                    <div className="flex space-x-4">
                      <button
                        onClick={handleApprovePaymentRequest}
                        className=" bg-[#4B664C] py-[10px] px-[18px] text-white rounded-[8px] "
                      >
                        {loading ? "Approving..." : "Approve Payment"}
                      </button>

                    </div>
                  </div>

                </div>
              </div>
            </Modal>
          )} */}
        </>
      </PageStyle>
    </RouteLayout>
  );
};

export default PaymentRequest;
